import moment from 'moment';
import 'moment/locale/es';

export function ipremium(until){
  var ok = false;
  /* Until: 2019-11-25 06:00 */
  var d = new moment(until);
      d = d.unix();
      console.log('t', d);
  var t = new moment();
      t = t.unix();
      console.log('t', t);
  var c = ap_cookie_get('u_pm');

  if(d > t && (!c || c.length < 5)){
    /* Prémium / No loggeado */
    ok = false;
  }else{
    ok = true;
  }
  return ok;
}


function ap_cookie_get(name) {
  if (!name) {
    console.error("No se estableció un nombre para conseguir la cookie.");
    return false;
  }
  name = "ap_" + name;
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return false;
}
